export enum PaymentGatewayType {
    Adyen = 'Adyen',
    Braintree = 'Braintree',
    None = 'None',
    PciProxy = 'PciProxy',
    Stripe = 'Stripe',
}
